import { forwardRef } from "react";

import { Input } from "antd";
import { type InputProps } from "antd/lib/input/Input";

import { cn } from "@btnet/utilities-core";

import "./BuiInput.less";

/**
 * IBuiInputProps is the interface for BuiInput props.
 * Currently an alias for antd's InputProps; declared as its own type so
 * BuiInput-specific props can be added or narrowed without breaking consumers.
 */
export interface IBuiInputProps extends InputProps {
  "data-testid"?: string; // Optional prop for testing purposes
}

/**
 * BuiInput component - a styled wrapper around antd Input.
 * Applies the `bui-input` class for BDS-themed styling and forwards a ref to the
 * underlying antd Input. All antd InputProps are supported and passed through.
 * @param props - IBuiInputProps defining the input's behavior and appearance
 * @param ref - forwarded ref to the underlying antd Input instance
 * @returns JSX.Element representing the input
 * @example
 * <BuiInput placeholder="Search" value={value} onChange={handleChange} />
 */
export const BuiInput = forwardRef<Input, IBuiInputProps>((props, ref) => {
  return (
    <Input {...props} className={cn("bui-input", props.className)} ref={ref} />
  );
});

BuiInput.displayName = "BuiInput";
